import { render } from "./modal-remove-teachers-from-group.vue?vue&type=template&id=0ebcbe1f&scoped=true"
import script from "./modal-remove-teachers-from-group.vue?vue&type=script&lang=js"
export * from "./modal-remove-teachers-from-group.vue?vue&type=script&lang=js"

import "./modal-remove-teachers-from-group.vue?vue&type=style&index=0&id=0ebcbe1f&lang=stylus&scoped=true"

import exportComponent from "/var/www/docker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ebcbe1f"],['__file',"src/components/admin-dashboard/modals/modal-remove-teachers-from-group.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0ebcbe1f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0ebcbe1f', __exports__)) {
    api.reload('0ebcbe1f', __exports__)
  }
  
  module.hot.accept("./modal-remove-teachers-from-group.vue?vue&type=template&id=0ebcbe1f&scoped=true", () => {
    api.rerender('0ebcbe1f', render)
  })

}


export default __exports__